export function EmailIconWhite({ width = 17, height = 11 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 17 11">
      <g>
        <g>
          <path
            fill="#fff"
            d="M15.506 0H1.494C.67 0 0 .62 0 1.375v8.25C0 10.385.674 11 1.494 11h14.012C16.325 11 17 10.388 17 9.625v-8.25C17 .62 16.334 0 15.506 0zm-.21.917L9.557 6.17c-.282.26-.657.403-1.056.403-.4 0-.774-.143-1.057-.404L1.703.917h13.594zM.997 9.438V1.562L5.3 5.502.996 9.438zm.708.645L6.007 6.15l.732.67c.47.433 1.096.672 1.761.672.665 0 1.29-.239 1.76-.67l.733-.672 4.303 3.934H1.704zm14.3-.645l-4.305-3.936 4.305-3.94v7.876z"
          ></path>
        </g>
      </g>
    </svg>
  );
}
